import { ByzzerPDFViewer } from "@/components/ByzzerPDFViewer";
import ByzzerModal2 from "@/components/modals/ByzzerModal2";


function MyHomePagePDFViewer({handlePDFModal}){

const baseClassName = 'home-page-pdf-viewer'

return (
    <ByzzerModal2 className={baseClassName} wrapperClassName type>
        <ByzzerModal2.Content className={`${baseClassName}__content`}>
            <ByzzerPDFViewer handlePDFModal={handlePDFModal}></ByzzerPDFViewer>
        </ByzzerModal2.Content>
    </ByzzerModal2>
)
}

export default MyHomePagePDFViewer;